import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { UserInfoService } from '../../../services/user-info.service';
import { Observable } from 'rxjs';
import {
  CreatePaymentViewDto,
  PaymentViewDto,
  PaymentViewListDto,
} from '../models/payment-view.models';
import { SortTableService } from '../../../services/sort-table.service';
import { FilterSearchResultDto } from 'src/app/models/filter.model';

@Injectable({
  providedIn: 'root',
})
export class PaymentViewDataService {
  agentId: string | undefined;
  userId: number | undefined;

  sort: string | undefined;

  constructor(
    private apiService: ApiService,
    private userInfoService: UserInfoService,
    private sortTableService: SortTableService
  ) {
    this.userInfoService.userId$.subscribe({
      next: (res) => {
        this.userId = res;
      },
    });

    this.userInfoService.agentId$.subscribe({
      next: (res) => {
        this.agentId = res;
      },
    });

    this.sortTableService.sortColum$.subscribe({
      next: (res) => {
        this.sort = res;
      },
    });
  }

  loadPaymentViewFilter(): Observable<any> {
    const url = `/agents/${this.agentId}/payment_types/filter`;
    return this.apiService.httpGet<any>(url);
  }

  loadPaymentViewList(
    page: number,
    search: string | undefined = '',
    data?: any
  ): Observable<PaymentViewListDto> {
    const url = `/agents/${this.agentId}/payment_types/filter?page_number=${page}&per_page=20&${this.sort}&search=${search}`;
    return this.apiService.httpPost<PaymentViewListDto>(url, data);
  }

  loadSearchList(data: any): Observable<FilterSearchResultDto> {
    const url = `/agents/${this.agentId}/payment_types/filter/list?page_number=0&per_page=10`;
    return this.apiService.httpPost<FilterSearchResultDto>(url, data);
  }

  loadSearchPaymentTypeList(searchWord: string): Observable<FilterSearchResultDto> {
    const url = `/agents/${this.agentId}/payment_types/search?page_number=0&per_page=10&order=ASC&field=PAYMENT_TYPE_ID&search=${searchWord}`;
    return this.apiService.httpGet<FilterSearchResultDto>(url);
  }

  loadDetailPaymentView(id: number): Observable<PaymentViewDto> {
    const url = `/agents/${this.agentId}/payment_types/${id}`;
    return this.apiService.httpGet<PaymentViewDto>(url);
  }

  loadPaymentViewSelect(): Observable<any> {
    const url = `/agents/${this.agentId}/payment_types/details/filter`;
    return this.apiService.httpGet<any>(url);
  }

  changeStatusPaymentView(id: string, state: boolean): Observable<void> {
    const url = `/agents/${this.agentId}/payment_types/${id}?is_blocked=${state}`;
    return this.apiService.httpPatch<void>(url);
  }

  createPaymentView(data: CreatePaymentViewDto): Observable<void> {
    const url = `/agents/${this.agentId}/payment_types`;
    return this.apiService.httpPost<void>(url, data);
  }

  editPaymentView(
    data: CreatePaymentViewDto,
    paymentViewId: number
  ): Observable<void> {
    const url = `/agents/${this.agentId}/payment_types/${paymentViewId}`;
    return this.apiService.httpPut<void>(url, data);
  }

  deletePaymentViewGroup(ids: number[]): Observable<void> {
    const queryParams = ids.map((id) => `paymentTypesIds=${id}`).join('&');
    const url = `/agents/${this.agentId}/payment_types?${queryParams}`;
    return this.apiService.httpDelete<void>(url);
  }
}
